import { useSettings } from '@/data/Settings';
import { SKIP_PARSING_ESPOTS_EXCEPTIONS_USER_DATA_KEY } from '@/components/content/EMarketingSpot/constants';
import { useMemo } from 'react';

/**
 * Skip parsing EMarketingSpot content if the EMarketingSpot name is not in the list of exceptions.
 */
export const useSkipParsing = ({ emsName }: { emsName: string }) => {
	const { settings } = useSettings();

	const value = settings?.userData[SKIP_PARSING_ESPOTS_EXCEPTIONS_USER_DATA_KEY] ?? '';

	return useMemo(() => {
		const emsNameExceptions = value.split(',');

		return !emsNameExceptions.includes(emsName);
	}, [emsName, value]);
};
